import React from 'react';
import { Box, Grid } from '@mui/material';
import { dataConstants } from '../../../constants';
import NoData from '../../_common/NoData';
import { Divider, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LoadingItem from '../../_common/Skeleton/stock';
import dynamic from 'next/dynamic';
// import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
// import CollapseCard from '../CollapseCard';

// const NewHomePrices = dynamic(() => import('./NewHomePrices'),
//   { loading: () => <LoadingItem /> })
// const NewHomeSales = dynamic(() => import('./NewHomeSales'),
//   { loading: () => <LoadingItem /> })
// const HomeOwnershipRate = dynamic(() => import('./HomeOwnershipRate'),
//   { loading: () => <LoadingItem /> })
// const PermitsStartsCompletions = dynamic(() => import('./PermitsStartsCompletions'),
//   { loading: () => <LoadingItem /> })
// const UnderConstruction = dynamic(() => import('./UnderConstruction'),
//   { loading: () => <LoadingItem /> })
// const HousingStarts = dynamic(() => import('./HousingStarts'),
//   { loading: () => <LoadingItem /> })
// const SalesTrend = dynamic(() => import('./SalesTrend'),
//   { loading: () => <LoadingItem /> })
// const RegionalSales = dynamic(() => import('./RegionalSales'),
//   { loading: () => <LoadingItem /> })
// const ByStageOfConstruction = dynamic(() => import('./ByStageOfConstruction'),
//   { loading: () => <LoadingItem /> })
// const StageOfConstruction = dynamic(() => import('./StageOfConstruction'),
//   { loading: () => <LoadingItem /> })
// const MonthsSupply = dynamic(() => import('./MonthsSupply'),
//   { loading: () => <LoadingItem /> })
// const MonthsOnSale = dynamic(() => import('./MonthsOnSale'),
//   { loading: () => <LoadingItem /> })
// const AnnualVacancyRate = dynamic(() => import('./AnnualVacancyRate'),
//   { loading: () => <LoadingItem /> })
// const RegionalVacantUnitsForSale = dynamic(() => import('./RegionalVacantUnitsForSale'),
//   { loading: () => <LoadingItem /> })
// const RegionalOwnershipRate = dynamic(() => import('./RegionalOwnershipRate'),
//   { loading: () => <LoadingItem /> })
// const ManufacturedHomePrices = dynamic(() => import('./ManufacturedHomePrices'),
//   { loading: () => <LoadingItem /> })
// const RegionalPrices = dynamic(() => import('./RegionalPrices'),
//   { loading: () => <LoadingItem /> })
// const ManufacturedHomesSold = dynamic(() => import('./ManufacturedHomesSold'),
//   { loading: () => <LoadingItem /> })


import NewHomePrices from './NewHomePrices';
import NewHomeSales from './NewHomeSales';
import HomeOwnershipRate from './HomeOwnershipRate';
import PermitsStartsCompletions from './PermitsStartsCompletions';
import UnderConstruction from './UnderConstruction';
import HousingStarts from './HousingStarts';
import SalesTrend from './SalesTrend';
import RegionalSales from './RegionalSales';
import ByStageOfConstruction from './ByStageOfConstruction';
import StageOfConstruction from './StageOfConstruction';
import MonthsSupply from './MonthsSupply';
import MonthsOnSale from './MonthsOnSale';
import AnnualVacancyRate from './AnnualVacancyRate';
import RegionalVacantUnitsForSale from './RegionalVacantUnitsForSale';
import RegionalOwnershipRate from './RegionalOwnershipRate';
import ManufacturedHomePrices from './ManufacturedHomePrices';
import RegionalPrices from './RegionalPrices';
import ManufacturedHomesSold from './ManufacturedHomesSold';

const { ECO_SECTION_CODES } = dataConstants || {};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .col-md-4:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#fbfbfc',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(2),
    paddingBottom: 0,
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .section': {
    minHeight: '3.4rem',
    borderBottom: '1px solid #eae9ee',
    borderColor: '#eae9ee',
    padding: '9px 10px',
    verticalAlign: 'middle',
    background: '#fbfbfc',
    fontSize: '.875rem',
    '& .option-title': {
      color: '#000000 !important',
      fontSize: '.875rem',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      // fontWeight: '700 !important'
    },
    '& button, .share-wrapper': {
      visibility: 'hidden'
    },
    '.option-desc': {
      color: '#333 !important',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  '& .option-desc .MuiTypography-body1': {
    fontSize: '.875rem !important',
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const USHousingMarket = ({ data, themes, getChartData, selectedInfo, onChangeInfo, doAppAction, adStyle }) => {
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClick = (message) => () => {
    setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  //housing data
  const houData = {};
  const dataArr = data && data.find(d => d.section_code === ECO_SECTION_CODES.HOU_DATA) ? data.filter(d => d.section_code === ECO_SECTION_CODES.HOU_DATA) : undefined;

  dataArr && dataArr.forEach(d => {
    houData[d.settings && d.settings.dataSetName ? d.settings.dataSetName : d.section_code] = (d.tabData || []);
  });
  // let houData = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_DATA) : undefined;
  // houData = houData && houData.tabData && houData.tabData.length > 0 ? houData.tabData : undefined;

  // //over price
  // const overPrice = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_OVER_PRICE) : undefined;
  // const overPriceChart = overPrice && overPrice.tabData && overPrice.tabData.length > 0 ? getChartData(overPrice.tabData[0], getTabData(houData, overPrice, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //over sales
  // const overSales = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_OVER_SALES) : undefined;
  // const overSaleChart = overSales && overSales.tabData && overSales.tabData.length > 0 ? getChartData(overSales.tabData[0], getTabData(houData, overSales, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //home ownership
  // const homeOwn = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_OVER_OWN) : undefined;
  // const homeOwnChart = homeOwn && homeOwn.tabData && homeOwn.tabData.length > 0 ? getChartData(homeOwn.tabData[0], getTabData(houData, homeOwn, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //home permits
  // const homePer = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_PERMITS) : undefined;
  // const homePerChart = homePer && homePer.tabData && homePer.tabData.length > 0 ? getChartData(homePer.tabData[0], getTabData(houData, homePer, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //under construction
  // const homeConst = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_UNDER_CONST) : undefined;
  // const homeConstChart = homeConst && homeConst.tabData && homeConst.tabData.length > 0 ? getChartData(homeConst.tabData[0], getTabData(houData, homeConst, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //under construction sales
  // const underConstSales = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_CONST_TYPE) : undefined;
  // const underConstSaleChart = underConstSales && underConstSales.tabData && underConstSales.tabData.length > 0 ? getChartData(underConstSales.tabData[0], getTabData(houData, underConstSales, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //sales trend
  // const salesTrend = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_HOME_SOLD) : undefined;
  // const salesTrendChart = salesTrend && salesTrend.tabData && salesTrend.tabData.length > 0 ? getChartData(salesTrend.tabData[0], getTabData(houData, salesTrend, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //sales religional
  // const salesReg = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_HOME_SOLD_REG) : undefined;
  // const salesRegChart = salesReg && salesReg.tabData && salesReg.tabData.length > 0 ? getChartData(salesReg.tabData[0], getTabData(houData, salesReg, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //sales type
  // const salesType = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_HOME_SOLD_TYPE) : undefined;
  // const salesTypeChart = salesType && salesType.tabData && salesType.tabData.length > 0 ? getChartData(salesType.tabData[0], getTabData(houData, salesType, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //construction stage
  // const forSaleStage = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_FORSALE_STAGE) : undefined;
  // const forSaleStageChart = forSaleStage && forSaleStage.tabData && forSaleStage.tabData.length > 0 ? getChartData(forSaleStage.tabData[0], getTabData(houData, forSaleStage, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //monthly supply
  // const monSupply = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_FORSALE_MTH) : undefined;
  // const monSupplyChart = monSupply && monSupply.tabData && monSupply.tabData.length > 0 ? getChartData(monSupply.tabData[0], getTabData(houData, monSupply, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //monthly sales
  // const monSales = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_FORSALE_MOS) : undefined;
  // const monSalesChart = monSales && monSales.tabData && monSales.tabData.length > 0 ? getChartData(monSales.tabData[0], getTabData(houData, monSales, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //vacancy rate
  // const vacancy = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_VACANCY_RATE) : undefined;
  // const vacancyChart = vacancy && vacancy.tabData && vacancy.tabData.length > 0 ? getChartData(vacancy.tabData[0], getTabData(houData, vacancy, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //religional trend
  // const regTrend = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_VACANCY_REG) : undefined;
  // const regTrendChart = regTrend && regTrend.tabData && regTrend.tabData.length > 0 ? getChartData(regTrend.tabData[0], getTabData(houData, regTrend, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //reg ownership rate
  // const regOwn = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_VACANCY_RGE_OWN) : undefined;
  // const regOwnChart = regOwn && regOwn.tabData && regOwn.tabData.length > 0 ? getChartData(regOwn.tabData[0], getTabData(houData, regOwn, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //mfg price
  // const mfg = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_MFG_PRICE) : undefined;
  // const mfgChart = mfg && mfg.tabData && mfg.tabData.length > 0 ? getChartData(mfg.tabData[0], getTabData(houData, mfg, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //mfg reg
  // const mfgReg = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_MFG_REG) : undefined;
  // const mfgRegChart = mfgReg && mfgReg.tabData && mfgReg.tabData.length > 0 ? getChartData(mfgReg.tabData[0], getTabData(houData, mfgReg, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  // //mfg shipping sales
  // const shipping = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_MEG_SALES) : undefined;
  // const shippingChart = shipping && shipping.tabData && shipping.tabData.length > 0 ? getChartData(shipping.tabData[0], getTabData(houData, shipping, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  return (
    <NoData noData={!data && !data?.length > 0} >
      <Box className="hou-section">
        <Box className="row sum-r eco-hou-over">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5, mt: 1 }}>
              <Box className="Item-Head">
                <Typography component="h2" className="option-title" sx={{ mr: 'auto' }} >
                  {`Overview of the US Housing Market`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <NewHomePrices
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <NewHomeSales
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <HomeOwnershipRate
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box className="row sum-r eco-hou-const">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box className="Item-Head">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`New Construction`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <PermitsStartsCompletions
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <UnderConstruction
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <HousingStarts
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box className="row sum-r eco-hou-home-s">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box className="Item-Head">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`New Home Sales`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <SalesTrend
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <RegionalSales
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <ByStageOfConstruction
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box className="row sum-r eco-hou-sales">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box className="Item-Head">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`For Sales`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <StageOfConstruction
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <MonthsSupply
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <MonthsOnSale
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box className="row sum-r eco-hou-van">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box className="Item-Head">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`Vacancy`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <AnnualVacancyRate
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <RegionalVacantUnitsForSale
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <RegionalOwnershipRate
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box className="row sum-r eco-hou-mfg">
          <Box className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box className="Item-Head">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`Mfg Home`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <ManufacturedHomePrices
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <RegionalPrices
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{}}>
                    <ManufacturedHomesSold
                      data={data}
                      selectedInfo={selectedInfo}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                      getChartData={getChartData}
                      houData={houData}
                      themes={themes}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
      </Box>
    </NoData >
  );
}

export default (USHousingMarket)
